import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

/**
 * WordPress dependencies
 */
import '@wordpress/core-data';
import '@wordpress/block-editor';
import '@wordpress/editor';
import { registerBlockType, setDefaultBlockName, setFreeformContentHandlerName, setUnregisteredTypeHandlerName, setGroupingBlockName, unstable__bootstrapServerSideBlockDefinitions } from // eslint-disable-line camelcase
'@wordpress/blocks';
/**
 * Internal dependencies
 */

import * as paragraph from './paragraph';
import * as image from './image';
import * as heading from './heading';
import * as quote from './quote';
import * as gallery from './gallery';
import * as archives from './archives';
import * as audio from './audio';
import * as button from './button';
import * as calendar from './calendar';
import * as categories from './categories';
import * as code from './code';
import * as columns from './columns';
import * as column from './column';
import * as cover from './cover';
import * as embed from './embed';
import * as file from './file';
import * as html from './html';
import * as mediaText from './media-text';
import * as navigationMenu from './navigation-menu';
import * as navigationMenuItem from './navigation-menu-item';
import * as latestComments from './latest-comments';
import * as latestPosts from './latest-posts';
import * as legacyWidget from './legacy-widget';
import * as list from './list';
import * as missing from './missing';
import * as more from './more';
import * as nextpage from './nextpage';
import * as preformatted from './preformatted';
import * as pullquote from './pullquote';
import * as reusableBlock from './block';
import * as rss from './rss';
import * as search from './search';
import * as group from './group';
import * as separator from './separator';
import * as shortcode from './shortcode';
import * as spacer from './spacer';
import * as subhead from './subhead';
import * as table from './table';
import * as textColumns from './text-columns';
import * as verse from './verse';
import * as video from './video';
import * as tagCloud from './tag-cloud';
import * as classic from './classic';
import * as socialLinks from './social-links';
import * as socialLink from './social-link';
/**
 * Function to register an individual block.
 *
 * @param {Object} block The block to be registered.
 *
 */

var registerBlock = function registerBlock(block) {
  if (!block) {
    return;
  }

  var metadata = block.metadata,
      settings = block.settings,
      name = block.name;

  if (metadata) {
    unstable__bootstrapServerSideBlockDefinitions(_defineProperty({}, name, metadata));
  }

  registerBlockType(name, settings);
};
/**
 * Function to register core blocks provided by the block editor.
 *
 * @example
 * ```js
 * import { registerCoreBlocks } from '@wordpress/block-library';
 *
 * registerCoreBlocks();
 * ```
 */


export var registerCoreBlocks = function registerCoreBlocks() {
  [// Common blocks are grouped at the top to prioritize their display
  // in various contexts — like the inserter and auto-complete components.
  paragraph, image, heading, gallery, list, quote, // Register all remaining core blocks.
  shortcode, archives, audio, button, calendar, categories, code, columns, column, cover, embed].concat(_toConsumableArray(embed.common), _toConsumableArray(embed.others), [file, group, window.wp && window.wp.oldEditor ? classic : null, // Only add the classic block in WP Context
  html, mediaText, latestComments, latestPosts, missing, more, nextpage, preformatted, pullquote, rss, search, separator, reusableBlock, spacer, subhead, table, tagCloud, textColumns, verse, video]).forEach(registerBlock);
  setDefaultBlockName(paragraph.name);

  if (window.wp && window.wp.oldEditor) {
    setFreeformContentHandlerName(classic.name);
  }

  setUnregisteredTypeHandlerName(missing.name);

  if (group) {
    setGroupingBlockName(group.name);
  }
};
/**
 * Function to register experimental core blocks depending on editor settings.
 *
 * @param {Object} settings Editor settings.
 *
 * @example
 * ```js
 * import { __experimentalRegisterExperimentalCoreBlocks } from '@wordpress/block-library';
 *
 * __experimentalRegisterExperimentalCoreBlocks( settings );
 * ```
 */

export var __experimentalRegisterExperimentalCoreBlocks = process.env.GUTENBERG_PHASE === 2 ? function (settings) {
  var __experimentalEnableLegacyWidgetBlock = settings.__experimentalEnableLegacyWidgetBlock,
      __experimentalEnableMenuBlock = settings.__experimentalEnableMenuBlock;
  [__experimentalEnableLegacyWidgetBlock ? legacyWidget : null, __experimentalEnableMenuBlock ? navigationMenu : null, __experimentalEnableMenuBlock ? navigationMenuItem : null, socialLinks].concat(_toConsumableArray(socialLink.sites)).forEach(registerBlock);
} : undefined;
//# sourceMappingURL=index.js.map